import {Component, ViewChild, TemplateRef} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageEvent } from "@angular/material/paginator";
import {BaseComponent, ActionDialog} from "../../base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { CadastroEmpresaConsorcioComponent } from "../cadastro-empresa-consorcio/cadastro-empresa-consorcio.component";
import { CaracteristicaProdutoConsorcioService } from "../services/caracteristica-produto-consorcio.service";
import { CadastroCaracteristicaProdutoConsorcioComponent } from "../cadastro-caracteristica-produto-consorcio/cadastro-caracteristica-produto-consorcio.component";


@Component({
    selector: "app-lista-caracteristica-produto-consorcio",
    templateUrl: "./lista-caracteristica-produto-consorcio.component.html",
    styleUrls: ["./lista-caracteristica-produto-consorcio.component.scss"]
})

export class ListaCaracteristicaProdutoCosorcioComponent extends BaseComponent{
    user:any;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(ListaCaracteristicaProdutoCosorcioComponent, { static: false }) table!: ListaCaracteristicaProdutoCosorcioComponent;

    constructor(public _service: CaracteristicaProdutoConsorcioService,
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private _authService: AuthService) {
        super(dialog, snackBar);

        this.getAll();
        const strUser = this._authService.getUser();
this.user = JSON.parse(strUser? strUser : "{}");

    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){
        console.log(event);

        this.params.page = (event.pageIndex + 1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista de Caracteristica Produto Consórcio
     */
    getAll(): void {

        this.loadingIndicator = true;
        this._service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];

            },
            error => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {

                console.log("complete");
                this.loadingIndicator = false;
            }
        );
    }

    /**
     * Exclui Caracteristica Produto Consórcio
     * @param id
     */
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Excluir Caracteristica Produto Consórcio",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();
                    
                    lista.loadingIndicator = true;
                    lista._service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.closeLoading();
                            console.log("error: " + error);
                            lista.showError(error.message);

                        },
                        () => {

                            console.log("complete");
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }

    /**
     * Modal de cadastro
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastroCaracteristicaProdutoConsorcioComponent, {
            width: "400px",
            height: "80%"
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Caracteristica Produto Consórcio cadastrado com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar um novo registro.");
            }
        });
    }

    /**
     * Modal de edição
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(CadastroCaracteristicaProdutoConsorcioComponent, {
            width: "400px",
            height: "80%",
            data: { 
                id: id 
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {            
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Caracteristica Produto Consórcio atualizado com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar altera o registro");
            }
        });
    }

}